import React, { useEffect, useRef, useState } from "react";
import firebase from "../../firebase/firebase";
import { enviarNotificacionFCM } from "../../firebase/enviarNotificacionFCM";

const Pedidos = () => {
  const [pedidos, setPedidos] = useState([]);
  const [notificaciones, setNotificaciones] = useState([]);

  const pedidosNotificadosRef = useRef(new Set());
  const primeraCargaRef = useRef(true);


  // ⏱️ Marca el momento en que el admin se abrió
  const inicioAdminRef = useRef(Date.now());

  // 🔹 Escuchar pedidos en tiempo real
  useEffect(() => {
    const unsubscribe = firebase.db
      .collection("pedidos")
      .onSnapshot(
        (snapshot) => {
          // 📋 Lista de pedidos
          const pedidosData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setPedidos(pedidosData);

          // 🔔 Detectar pedidos nuevos (por ID, sin createdAt)
        const cambios = snapshot.docChanges();

          if (primeraCargaRef.current) {
            cambios.forEach((change) => {
              if (change.type === "added") {
                pedidosNotificadosRef.current.add(change.doc.id);
              }
            });

            primeraCargaRef.current = false;
          } else {
            cambios.forEach((change) => {
              if (change.type === "added") {
                const pedidoId = change.doc.id;

                // 🔒 Evitar notificar duplicados
                if (!pedidosNotificadosRef.current.has(pedidoId)) {
                  pedidosNotificadosRef.current.add(pedidoId);
                  mostrarNotificacion(change.doc.data());
                  
                }
              }
            });
          }
        },
        (error) => {
          console.error("❌ Error al escuchar pedidos:", error);
        }
      );

    return () => unsubscribe();
  }, []);

  // 🔔 Mostrar notificación en admin
  const mostrarNotificacion = (pedido) => {
  const mensaje = `🆕 Nuevo pedido del usuario ${pedido.idUsuario || ""}`;

  // 🔹 Enviar notificación FCM
  enviarNotificacionFCM(pedido);

  // 🔊 Sonido
  const audio = new Audio("/notify.mp3");
  audio.play().catch(() => {});

  // 🔔 Guardar en campana
  setNotificaciones((prev) => [
    {
      id: Date.now(),
      mensaje,
      fecha: new Date(),
    },
    ...prev,
  ]);
};


  // 🔹 Marcar pedido como completado
  const marcarComoCompletado = async (pedidoId) => {
    try {
      const pedidoRef = firebase.db.collection("pedidos").doc(pedidoId);
      const pedidoSnap = await pedidoRef.get();
      if (!pedidoSnap.exists) return console.log("⚠️ Pedido no encontrado");

      const pedidoData = pedidoSnap.data();

      const totalPedido =
        pedidoData.total ||
        pedidoData.detalle?.reduce(
          (sum, item) =>
            sum + (item.total || item.precio * item.cantidad),
          0
        );

      // 🔢 Generar númeroPedido
      const ventasRef = firebase.db.collection("ventas_realizadas");
      const lastVentaSnap = await ventasRef
        .orderBy("numeroPedido", "desc")
        .limit(1)
        .get();

      let nuevoNumero = 1;
      if (!lastVentaSnap.empty) {
        const lastVenta = lastVentaSnap.docs[0].data();
        const match = lastVenta.numeroPedido?.match(/PED-(\d+)/);
        if (match) nuevoNumero = parseInt(match[1]) + 1;
      }

      const numeroPedido = `PED-${String(nuevoNumero).padStart(6, "0")}`;

      // 💾 Guardar en ventas_realizadas
      await ventasRef.add({
        ...pedidoData,
        numeroPedido,
        total: totalPedido,
        completado: true,
        fechaCompletado: new Date(),
      });

      // 🗑️ Eliminar de pedidos
      await pedidoRef.delete();

      console.log(`✅ Pedido completado: ${numeroPedido}`);
    } catch (error) {
      console.error("❌ Error al completar pedido:", error);
      alert("Ocurrió un error al completar el pedido.");
    }
  };

  return (
    <div style={{ padding: 20 }}>
      {/* 🔔 Campana */}
      <div style={{ textAlign: "right", marginBottom: 10 }}>
        🔔 {notificaciones.length}
      </div>

      <h1 style={{ fontSize: "2rem", fontWeight: "bold", marginBottom: 20 }}>
        📋 Pedidos en tiempo real
      </h1>

      {pedidos.length === 0 ? (
        <p>No hay pedidos registrados.</p>
      ) : (
        pedidos.map((pedido) => (
          <div
            key={pedido.id}
            style={{
              border: "1px solid #ccc",
              borderRadius: 10,
              padding: 15,
              marginBottom: 20,
              backgroundColor: "#fff3e0",
            }}
          >
            <h2 style={{ color: "#f57c00" }}>
              Pedido Pendiente
            </h2>

            <p><strong>Usuario:</strong> {pedido.idUsuario}</p>
            <p><strong>Tipo de compra:</strong> {pedido.tipoCompra}</p>

            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={styles.th}>Producto</th>
                  <th style={styles.th}>Cantidad</th>
                  <th style={styles.th}>Precio</th>
                  <th style={styles.th}>Total</th>
                </tr>
              </thead>
              <tbody>
                {pedido.detalle?.map((item, i) => (
                  <tr key={i}>
                    <td style={styles.td} translate="no">{item.nombre}</td>
                    <td style={styles.td}>{item.cantidad}</td>
                    <td style={styles.td}>S/ {item.precio}</td>
                    <td style={styles.td}>
                      {item.total || item.precio * item.cantidad}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <button
              onClick={() => marcarComoCompletado(pedido.id)}
              style={{
                marginTop: 15,
                padding: "8px 12px",
                backgroundColor: "#4caf50",
                color: "#fff",
                border: "none",
                borderRadius: 5,
                cursor: "pointer",
              }}
            >
              Marcar como completado
            </button>
          </div>
        ))
      )}
    </div>
  );
};

const styles = {
  th: {
    border: "1px solid #ccc",
    padding: 6,
    backgroundColor: "#ffe0b2",
  },
  td: {
    border: "1px solid #ddd",
    padding: 6,
    textAlign: "center",
  },
};

export default Pedidos;

